import React from "react";
import "./ValidateOrderModal.css";

const CAPACITY_LABELS = {
  delivery_capacity: "Delivery Unavailable",
  takeaway_capacity: "Takeaway Unavailable",
  dine_in_capacity: "Dine-in Unavailable",
};

const ValidateOrderModal = ({
  show = false,
  message = "There seems to be an issue with your order.",
  capacity_type = null,
  onShowMe,
  onCancel,
}) => {
  if (!show) return null;

  const title = CAPACITY_LABELS[capacity_type] || "Order Issue Detected";

  return (
    <div className="vom-overlay" onClick={onCancel}>
      <div className="vom-modal" onClick={(e) => e.stopPropagation()}>
        {/* Icon */}
        <div className="vom-icon-wrap">
          <span className="vom-icon">⚠️</span>
        </div>

        {/* Title */}
        <h5 className="vom-title">{title}</h5>

        {/* Message */}
        <p className="vom-message">{message}</p>

        {/* Divider */}
        <div className="vom-divider" />

        {/* Buttons */}
        <div className="vom-footer">
          <button className="vom-btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="vom-btn-show" onClick={onShowMe}>
           {capacity_type === 'delivery_capacity' ? 'Show Takeaway Menu' : 'Show Ready Meals'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidateOrderModal;
